//@TODO: Need Audit
import $ from 'jquery';
import Popup from 'shared/components/popups/popup';
import { isMobile } from 'shared/vidio_helpers';
import Lights from 'shared/components/lights';
const Tmpl = require('blueimp-tmpl');

const deletePopup = require('templates/popups/dashboard_collection_delete_video.jst.jade');

const ManageVideoWidget = {
  metaCurrentUser: "meta[name=current-username]",
  metaCurrentUserId: "meta[name=current-user-id]",
  metaOgUrl: "meta[property='og:url']",
  videoWidgetSelector: ".video-widget, .video-widget-column, .video-card",
  videoManageSelector: ".video-widget__manage",

  show: function() {
    var username = $(this.metaCurrentUser).attr('content');
    var userId = $(this.metaCurrentUserId).attr('content');
    if (username && $(this.videoManageSelector).length > 0) {
      var fullSelector = $('body').find(this.videoWidgetSelector);
      var isDashboard = $('body').hasClass('dashboard channels edit') || $('body').hasClass('mobile channels show');
      var ownChannel = $('body').hasClass('users show') && $(this.metaOgUrl).attr('content').includes(username);
      var elements = $(fullSelector);
      if (elements.length > 0) {
        var selector = this.videoManageSelector;
        elements.each(function() {
          var videoId = $(this).data('video-id');
          var dataTemplate = ManageVideoWidget.getVideoWidgetTmpl(videoId, userId);
          $(this).find(selector).css("display", "block");
          $(this).find(selector).html(dataTemplate);

          var channelId = $(this).find(selector).data("channel-id");

          if ($(this).data('video-username') === username) {
            if(!isDashboard) {
              $(this).find('.site-wide__remove-from-collection').remove();
            }

            var isSameChannel = (channelId === $(this).data('video-channel-id'));
            if(isSameChannel) {
              $(this).find('.site-wide__remove-from-collection').remove();
            }
          } else {
            $(this).find('.site-wide__edit').remove();
            $(this).find('.site-wide__delete').remove();
            $(this).find('.site-wide__unpublish').remove();
            if(!isDashboard && !ownChannel ) {
              $(this).find('.site-wide__remove-from-collection').remove();
            }
          }

          ManageVideoWidget.bindRemoveFromCollection(channelId, videoId);
        });
      }
    }
  },

  getVideoWidgetTmpl(videoId, userId){
    return Tmpl("manage-video-template", { "video_id" : videoId, "user_id": userId, isMobile: isMobile() });
  },

  bindRemoveFromCollection: function(channelId, videoId) {
    $('.site-wide__remove-from-collection[data-video-id='+ videoId +']').on('click', function(e) {
      e.preventDefault();
      ManageVideoWidget.showConfirm(channelId, videoId);
    });
  },

  removeFromCollection: function(channelId, videoId) {
    $.ajax({
      method: 'DELETE',
      url: '/collections/' + channelId + '.json?video_id=' + videoId,
      dataType: 'json'
    })
    .done(() => {
      ManageVideoWidget.onRemoveFromCollectionSuccess();
    });
  },

  onRemoveFromCollectionSuccess: function() {
    window.location.reload();
  },

  showConfirm: function(channelId, videoId) {
    var lang = $("meta[name=language]").attr("content");
    var popup = Popup.new('', 'dashboard_collection_delete_video');
    var params = {
      videoId: videoId,
      channelId: channelId,
      locale: window.Locale[lang]
    };
    var content = $(deletePopup(params));
    var html = popup.content(content);
    $('body').append(html);

    ManageVideoWidget.bindOnClose();
    ManageVideoWidget.bindOnRemove();
  },

  bindOnClose: function() {
    $('.popup-button__close').on('click', function() {
      ManageVideoWidget.onClose();
    });
  },

  onClose: function() {
    $('.popup').remove();
    Lights.on();
  },

  bindOnRemove: function() {
    $('.popup-button__remove').on('click', function() {
      var channelId = $(this).data('channel-id');
      var videoId = $(this).data('video-id');

      ManageVideoWidget.removeFromCollection(channelId, videoId);
      ManageVideoWidget.onClose();
    });
  }
};

export default ManageVideoWidget;
